import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FeedArticleDetail } from '../types';
import { DetailContainer } from './DetailContainer';
import { ListContainer } from './ListContainer';

let articleFromList: FeedArticleDetail;

export const setArticleFromList = (data: FeedArticleDetail) => {
  articleFromList = data;
};

export const DesktopContainer = memo(() => {
  const { id: urlId } = useParams<{ id: string }>() || {};
  // 做缓存用
  const [id, setId] = useState(urlId);

  useEffect(() => {
    if (urlId) {
      setId(urlId);
    }
  }, [urlId]);

  // 直接进入 detail/id 页面，不需要渲染 ListContainer
  const [listMatched, setListMatched] = useState(!id);

  useEffect(() => {
    if (!id && !listMatched) {
      setListMatched(true);
    }
  }, [id, listMatched]);

  useLayoutEffect(() => {
    // @ts-ignore 标记内存清理，articleFromList 已通过形参传过去了，这里没用了
    articleFromList = null;
  }, []);

  return (
    <>
      {id ? <DetailContainer id={id} article={articleFromList} /> : null}
      {listMatched ? (
        <div style={{ display: id ? 'none' : 'block' }}>
          <ListContainer />
        </div>
      ) : null}
    </>
  );
});
